<div
  class="hierarchic-list-panel"
  [ngClass]="{'create': fieldParameters.canAddNew}"
>
  @if (searching) {
    <div class="hierarchic-list-panel__searching">
      <mat-progress-spinner
        mode="indeterminate"
        color="accent"
        [diameter]="16"
      ></mat-progress-spinner>

      <span>
        {{ 'TRANS__HIERARCHIC_LIST__LOADING' | translate }}
      </span>
    </div>
  }
  @else {
    @if (dataSource && treeControl) {
      <mat-tree
        [dataSource]="dataSource"
        [treeControl]="treeControl"
        class="hierarchic-tree"
      >
        <ul>
        <!-- This is the tree node template for leaf nodes -->
          <mat-tree-node
            *matTreeNodeDef="let node"
            matTreeNodePadding
            [matTreeNodePaddingIndent]="useNewDesign() ? 0 : 24"
          >
            <li
              [class.hierarchic-tree__child-node] = "getLevel(node) > 1 && useNewDesign()"
              [class]="getDepthClass(getLevel(node))"
            >
              <div class="mat-tree-node">
                <button
                  mat-icon-button
                  disabled
                  class="mat-tree-node__expand-button"
                  style="visibility: hidden;"
                  type="button"
                >
                  <mat-icon class="mat-icon-rtl-mirror">
                    chevron_right
                  </mat-icon>
                </button>

                @if (isArray) {
                  <mat-checkbox
                    [checked]="node['hierarchicNode']['$$isSelected']"
                    (change)="onNodeSelected(node, true)"
                    tabindex="-1"
                  ></mat-checkbox>
                }

                <button
                  class="hierarchic-list-panel__node-text"
                  mat-button
                  type="button"
                  [title]="node['$$name']"
                  (click)="onNodeSelected(node, true)"
                >
                <span class="hierarchic-list-panel__name">
                  {{ getNodeDisplayString(node) }}
                </span>

                  <!--@if (node.hierarchicNode.location_type_id_value && !isArray) {
                    <span class="hierarchic-list-panel__name">
                      ({{ node.hierarchicNode.location_type_id_value }})
                    </span>
                  }-->

                  @if (node.authority === 'KulturNav') {
                    <span class="concept-authority"></span>
                  }
                </button>

                @if (node['$$description']) {
                  <button
                    (click)="openDescription(node)"
                    type="button"
                    mat-icon-button
                    class="hierarchic-list-panel__node-description"
                  >
                    <mat-icon>
                      info
                    </mat-icon>
                  </button>
                }
              </div>
            </li>
            <!-- Placeholder button to align with expandable nodes -->
          </mat-tree-node>

          <!-- This is the tree node template for expandable nodes -->
          <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding
            [matTreeNodePaddingIndent]="useNewDesign() ? 0 : 24"
          >
            <li
              [class.hierarchic-tree__child-node] = "(treeControl.isExpanded(node) || getLevel(node) > 1) && useNewDesign()"
              [class]="getDepthClass(getLevel(node))"
            >
              <div class="mat-tree-node">
                <button
                  mat-icon-button
                  matTreeNodeToggle
                  type="button"
                  class="mat-tree-node__expand-button"
                  (click)="onNodeOpened(node)"
                  [attr.aria-label]="'Toggle ' + node['$$name']"
                >
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>

                @if (isArray) {
                  <mat-checkbox
                    [checked]="node['hierarchicNode']['$$isSelected']"
                    (change)="onNodeSelected(node, false)"
                  ></mat-checkbox>
                }

                <button
                  class="hierarchic-list-panel__node-text"
                  mat-button type="button"
                  [title]="node['$$name']"
                  (click)="onNodeSelected(node, false)"
                >
                  <span  class="hierarchic-list-panel__name">
                    {{ getNodeDisplayString(node) }}
                  </span>

                  @if (node.hierarchicNode.location_type_id_value) {
                    <!--<span class="hierarchic-list-panel__name">
                      ({{ node.hierarchicNode.location_type_id_value }})
                    </span> -->

                    @if (getChildCount(node)) {
                      <span class="hierarchic-list-panel__children-counter">
                        {{ getChildCount(node) }}
                        @if (getChildCount(node) === 1) {
                          {{ 'TRANS__HIERARCHIC_LIST__CHILDREN_COUNT_ONE' | translate }}
                        }
                        @else if (getChildCount(node) > 1) {
                          {{ 'TRANS__HIERARCHIC_LIST__CHILDREN_COUNT_MORE' | translate }}
                        }
                      </span>
                    }
                  }

                  @if (node.authority === 'KulturNav') {
                    <span class="concept-authority"></span>
                  }
                </button>

                @if (node['$$description']) {
                  <button
                    (click)="openDescription(node)"
                    type="button"
                    mat-icon-button
                    class="hierarchic-list-panel__node-description"
                  >
                    <mat-icon>
                      info
                    </mat-icon>
                  </button>
                }
              </div>

              <ul
                [class.hierarchic-tree-invisible]="!treeControl.isExpanded(node)"
                class="hierarchic-list-panel__node-children"
              >
                <ng-container matTreeNodeOutlet></ng-container>
              </ul>
            </li>
          </mat-tree-node>
        </ul>

        <mat-tree-node
          *matTreeNodeDef="let node; when: isLoadMore"
          matTreeNodePadding
          matTreeNodePaddingIndent="24"
        >
          @if (!node['isLoading']) {
            <button
              mat-stroked-button
              class="hierarchic-list-panel__loading-button"
              color="primary"
              type="button"
              (click)="onNodeLoadMore(node); $event.stopPropagation();"
            >
              {{'TRANS__HIERARCHIC_LIST__SHOW_MORE' | translate}}
            </button>
          }
          @else {
            <div class="hierarchic-list-panel__loading-more-spinner">
              <mat-progress-spinner
                mode="indeterminate"
                color="accent"
                [diameter]="16"
              ></mat-progress-spinner>

              <span>
                {{ 'TRANS__HIERARCHIC_LIST__LOADING' | translate }}
              </span>
            </div>
          }
        </mat-tree-node>
      </mat-tree>
    }
  }
</div>
